<div class ="chatView_container" [ngClass]="{'is-mobile-view': isMobileView}">
    <mat-sidenav-container class="chatView_SideNavContainer" [ngClass]="{'is-mobile-view': isMobileView}">
        <mat-sidenav #chatSideNav class="chatView_sideNav" [ngClass]="{'is-mobile-view': isMobileView}">
            @if(isMobileView){
                <div class="chatView_chatsList is-mobile-view">
                    <div class="chatView_chatsList-header-container is-mobile-view">
                        <span class="chatView_chatsList-headerText is-mobile-view">{{"chatView.chatsListHeaderText" | translate}} ({{userChats.length}})</span>
                        <button mat-icon-button (click)="closePastChatsSideNav()"  class="chatView_closeBtnSidenav"><mat-icon>close</mat-icon></button>
                    </div>
                    <mat-divider></mat-divider>
                     <div class="chatView_chatsListContent">
                         <mat-selection-list class="chatView_chatsListSelectionList is-mobile-view" color="primary" #chatsSelectionList [multiple]="false" [hideSingleSelectionIndicator]="true" (selectionChange)="chatSelectionChanged(chatsSelectionList.selectedOptions.selected)">
                             @for(currUserChat of userChats; track currUserChat.id){
                                 <mat-list-option [value]="currUserChat.id">
                                    <div class="chatView_chatItem">
                                        <span class="chatView_chatItemText">
                                            <span matListItemTitle class="chatView_chatItemTitle">{{currUserChat.title}}</span>
                                            <span matListItemLine>{{"chatView.lastUpdate" | translate}} {{currUserChat.lastUpdate| date: "MM-dd-yyyy"}}</span>       
                                        </span>
                                        <button mat-icon-button (click)="deleteChat(currUserChat.id)" class="chatView_deleteChatBtn"><mat-icon>delete</mat-icon></button>
                                    </div>
                                    </mat-list-option>
                                }
                            </mat-selection-list>
                        </div>
                    <div class="chatView_newChatBtn-container">
                        <div class="chatView_newChatBtn" (click)="startNewChatFromPastChatsSideNav()">{{"chatView.mobileToolbarEmptyStateText" | translate}} <mat-icon>add</mat-icon> </div>
                    </div>
                </div>            
            }    
        </mat-sidenav>
        <mat-sidenav-content class="chatView_sideNavContentContainer" [ngClass]="{'is-mobile-view': isMobileView}">    
            @if(!isMobileView){
                <div class="chatView_chatsList">
                    <div class="chatView_chatsList-header-container">
                        <span class="chatView_chatsList-headerText">{{"chatView.chatsListHeaderText" | translate}} ({{userChats.length}})</span>
                        <button mat-mini-fab class="chatView_chatsList-newChatBtn" (click)="startNewChat()" matTooltip="{{'chatView.restartChatButtonToolTip' | translate}}"><mat-icon>add</mat-icon></button>
                    </div>
                    <mat-divider style="margin-bottom:6px;"></mat-divider>
                    <mat-selection-list class="chatView_chatsListSelectionList" #chatsSelectionList [multiple]="false" [hideSingleSelectionIndicator]="true" (selectionChange)="chatSelectionChanged(chatsSelectionList.selectedOptions.selected)">
                        @for(currUserChat of userChats; track currUserChat.id){
                            <mat-list-option [value]="currUserChat.id">
                                <!-- <div class="chatView_chatItem">
                                    <span mat-list-text class="chatView_chatItemText"> -->
                                        <span matListItemTitle class="chatView_chatItemTitle">{{currUserChat.title}}</span>
                                        <span matListItemLine>{{"chatView.lastUpdate" | translate}} {{currUserChat.lastUpdate| date: "MM-dd-yyyy"}}</span>       
                                    <!-- </span> -->
                                    <button matListItemIcon	 mat-icon-button (click)="deleteChat(currUserChat.id)" class="chatView_deleteChatBtn"><mat-icon>delete</mat-icon></button>
                            </mat-list-option>
                        }
                    </mat-selection-list>        
                </div>   
            }
            @else{
                <!-- same as if mobile -->
                @if(presentPastChatsButton){
                    <div class="chatView_mobileToolbarHeader">
                        <div class="chatView_mobileToolbarWrapper">

                            <button mat-mini-fab class="chatView_chatsList-newChatBtn" (click)="openPastChats()" [ngClass]="{'is-mobile-view': isMobileView}" [style.padding]="isRTL ? '0 1.5px' : null"><mat-icon>{{'chatView.mobileToolbarPastChatsBtnDirection' | translate}}</mat-icon></button>
                            
                              @if(isEmpty){
                                <span class="chatView_mobileToolbarEmptyStateText">{{"chatView.mobileToolbarEmptyStateText" | translate}}</span>
                              }@else{
                                <span class="chatView_mobileToolbarHeaderText">{{currChatTitle}}</span>
                              }
                            
                            <button mat-mini-fab class="chatView_chatsList-newChatBtn" (click)="startNewChat()" [ngClass]="{'is-mobile-view': isMobileView}"  ><mat-icon>add</mat-icon></button>
                        </div>
                        
                        <mat-divider style="width: 100%;"></mat-divider>
                    </div>
                }
            }
            <div class="chatView_chatContainer" [ngClass]="{'is-mobile-view': isMobileView, 'force-use-cases': forceUseCases}" >
                @if ((isEmpty || forceUseCases) && !isAudioCommunicationEnabled){
                    <div class="chatView_emptyStateContainer" [ngClass]="{'force-use-cases': forceUseCases}">
                        <button mat-icon-button *ngIf="forceUseCases" class="chatView_useCasesCloseButton" (click)="hideUseCasesByUser()"><mat-icon>close</mat-icon></button>
                        <img class="chatView_consultantPhoto" src="{{imageRootFolder}}consultant_chat.png">
                        <div class="chatView_emptyStateTextContainer">
                            <span class="chatView_emptyStateHeader">{{"chatView.emptyStateHeader" | gender | translate}}</span>
                            @if(activeChatType == chatTypeEnumInstance.CareerIndividualConsultantLead){
                                <span class="chatView_emptyStateMesage" [ngClass]="{'is-mobile-view': isMobileView}" [innerHtml]="'chatView.emptyStateCareerChatMessage' | gender | translate"></span>    
                            }
                            @else{
                                <span class="chatView_emptyStateMesage" [ngClass]="{'is-mobile-view': isMobileView}" [innerHtml]="'chatView.emptyStateMessage' | gender | translate"></span>    
                            }
                        </div>
                        <app-chat-carousel [items]="carouselItems" [isLoading]="isCarouselLoading" (questionSelected)="handleCarouselSelectedQuestion($event)" class="chatView_carousel" [ngClass]="{'is-mobile-view': isMobileView}"></app-chat-carousel>
                    </div>    
                }
                @if (!isEmpty && !isAudioCommunicationEnabled){
                    <div class="chatView_messagesCotainer" [ngClass]="{'is-mobile-view': isMobileView}" #chatMessagesContainer>
                        @for(currMessage of oldMessages; track currMessage.id){
                            <div class="chatView_singleMessageContainer">
                                <app-chat-message 
                                class="chatView_message" 
                                [messageText]="currMessage.content" 
                                [isUserMessage]="currMessage.role == chatMessageRoles.USER"
                                [isLiveMessage]="false"
                                [userRating]="currMessage.userRating"
                                (messageLikedEvent)="messageLiked(currMessage.id)"
                                (messageDislikedEvent)="messageDisliked(currMessage.id)"
                                [ngClass]="{'user' : currMessage.role == chatMessageRoles.USER, 'server' : currMessage.role == chatMessageRoles.SERVER, 'is-mobile-view' : isMobileView}">
                            </app-chat-message>
                            </div>
                        }
                        @if(presentLiveMessage){
                            <app-chat-message 
                            class="chatView_message" 
                            [messageText]="liveMessage" 
                            [isUserMessage]="false"
                            [isLiveMessage]="true"
                            [ngClass]="{'server' : true, 'is-mobile-view' : isMobileView}">
                        </app-chat-message> 
                        }            
                    </div>
                }
                @if(isAudioCommunicationEnabled){
                    <div>
                        <div>
                            <app-audio-player-controler 
                              [isPlaying]="isPlaying"
                              [isRecording]="isRecording"
                              [isProcessing]="isAudioProcessing"
                              [isAudioOn]="chatAudioTTSuserEnabled">
                            </app-audio-player-controler>
                            <audio #audioElement autoplay></audio>
                        </div>
                    </div>               
                } 

                <app-audio-capture [captureEnabled]="isAudioCommunicationEnabled" (recordingStarted)="handleRecordingStarted()" (recordingCompleted)="handleUserRecordingCompleted($event)"></app-audio-capture>

                <div class="chatView_chatControls">
                    @if (shouldAllowAudioTTS){
                        @if (!chatAudioTTSuserEnabled){
                            <button mat-fab extended (click)="handleAudioToggle(true)" color="primary">
                                <mat-icon>mic</mat-icon>
                                <span>{{"chatView.switchToVoice" | translate}}</span>
                            </button>
                        }
                        @else{
                        <button mat-fab extended (click)="handleAudioToggle(false)" color="primary">
                            <mat-icon>keyboard</mat-icon>
                            <span>{{"chatView.switchToText" | translate}}</span>
                        </button>
                        }
                    }
                    @if(isAllowManagePeopleOfInterest && activeChatDetails){
                        <button mat-fab extended matBadge="{{activeChatDetails.poiList.length}}" [matBadgeHidden]="activeChatDetails.poiList.length == 0"matBadgeColor="accent" (click)="managePeopleOfInterest()" color="primary">
                            <mat-icon>person_add</mat-icon>
                            <span>{{"chatView.managePeopleOfInterestButton" | translate}}</span>
                        </button>
                    }
                </div>


                <div class="chatView_bottomPart" [ngClass]="{'is-mobile-view': isMobileView}">
                    <mat-divider></mat-divider>


                    @if(!isAudioCommunicationEnabled){
                        <app-chat-user-prompt #userPrompt class="chatView_userPrompt" [ngClass]="{'is-mobile-view': isMobileView}" [presentForceUseCases]="!isEmpty" (submitUserEntryEvent)="submitUserEntry($event)" (userForcedUseCasePresentation)="presentUseCasesByUser()"></app-chat-user-prompt>
                    }
                    <div class="chatView_privacyFooter" [ngClass]="{'is-mobile-view': isMobileView}">
                        <span class="chatView_privacyFooterText" [ngClass]="{'is-mobile-view': isMobileView}"> <img class="chatView_privacyFooterIcon" src="assets/common/lock.svg" />  {{"chatView.privacyFooterText" | translate}}</span>
                        <app-claro-tooltip-icon [translatedTooltipText]="'chatView.privacyFooterTooltipText' | translate" ></app-claro-tooltip-icon>
                    </div>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>